import React from "react";
import { Input, InputDate, TextAreaInput } from "../../Helpers/Input/Input";
import trans from "../../../utils";
import { useFormikContext } from "formik";
import dayjs from "dayjs";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import { ServiceType } from "../../../constants";

const RequestFormBody = ({ isEditing, editData }) => {
	const {
		values,
		handleChange,
		handleBlur,
		errors,
		touched,
		setFieldValue,
		setFieldTouched,
	} = useFormikContext();
	console.log("editdata", editData);
	return (
		<div className="form-section">
			<div className="row">
				<div className="col-lg-6">
					<InputDate
						title={trans("preferred time")}
						id="preferredTime"
						name="preferredTime"
						showTime={{ format: "HH:mm" }}
						onBlur={(value) => setFieldTouched("preferredTime", true)}
						onChange={(value) =>
							setFieldValue(
								"preferredTime",
								value ? dayjs(value).toISOString() : ""
							)
						}
						errors={errors.preferredTime}
						touched={touched.preferredTime}
						value={values.preferredTime || ""}
						min={dayjs()}
						minTime={dayjs()}
					/>
				</div>
				<div className="col-lg-6">
					<InputSelect
						id="serviceType"
						name="serviceType"
						label={trans("Type")}
						placeholder={trans("Select Service Type")}
						options={ServiceType}
						value={values.serviceType}
						onChange={(val) => setFieldValue("serviceType", val)}
						onBlur={() => setFieldTouched("serviceType", true)}
						errors={errors.serviceType}
						touched={touched.serviceType}
						formstyle="form-input select-z-index"
					/>
				</div>
				<div className="col-lg-12">
					<TextAreaInput
						title={trans("Description")}
						type="text"
						placeholder={trans("Write Request description")}
						formstyle="form-input"
						id="description"
						name="description"
						value={values.description}
						onChange={handleChange}
						onBlur={handleBlur}
						errors={errors.description}
						touched={touched.description}
						max={256}
					/>
				</div>
			</div>
		</div>
	);
};

export default RequestFormBody;
